/*
==============================================================================
パラメーター企業情報がある場合、サイト上のコンテンツを動的切り替え
==============================================================================
*/

// ======================= 企業情報取得 ======================= 

var url = new URL(window.location.href);
var params = url.searchParams;
var search = location.search;

if( search.match(/company%3D/) ){  
  //「=」がデコードされている場合
  var company_handle = search.substring(search.indexOf('company%3D')).replace("company%3D", "");  
  
  
}else if( search.indexOf('handle_') !== -1 && url.pathname == '/search' ){
//検索結果ページでストアフロントフィルタリング+2ページ目以降の処理    
  var search_url = search.match(/handle_(.*)AND/);  
  if (search_url != null) {
    var company_handle = search_url[1].replace("+", "").replace("%20", "");
  }
  
}else{
  // companyパラメーターがある場合
  var company_handle = params.get('company');  
}

// =======================DOM取得 ======================= 

// Header（商品を絞り込む）
if( document.getElementById("HeaderCollection01") !== null ){
  var dom_HeaderCollection01 = document.getElementById("HeaderCollection01");
}
if( document.getElementById("HeaderCollection02") !== null ){
  var dom_HeaderCollection02 = document.getElementById("HeaderCollection02");
}

// Header（検索フォーム）
if( document.getElementsByClassName('HeaderSearchInput') !== null ){
  var dom_HeaderSearchInput = document.getElementsByClassName('HeaderSearchInput');
}

//HeaderRegisterPc
if( document.getElementById("HeaderRegisterPc") !== null ){
  var dom_HeaderRegisterPc = document.getElementById("HeaderRegisterPc");  
}

//HeaderAccountSp
if( document.getElementById("HeaderAccountSp") !== null ){
  var dom_HeaderAccountSp = document.getElementById("HeaderAccountSp");
}

//HeaderAccountPc
if( document.getElementById("HeaderAccountPc") !== null ){
  var dom_HeaderAccountPc = document.getElementById("HeaderAccountPc");
}

// Header（カートドロワーのボタン）    
if( document.getElementById("HeaderCartMove") !== null ){
  var dom_HeaderCartMove = document.getElementById("HeaderCartMove");  
}

// Header Navigation（PC）    
var dom_HeaderGnaviPc_Top = document.getElementById("HeaderGnaviPc_Top");
var dom_HeaderGnaviPc_Collection = document.getElementById("HeaderGnaviPc_Collection");
var dom_HeaderGnaviPc_Blog = document.getElementById("HeaderGnaviPc_Blog");
var dom_HeaderGnaviPc_Favorite = document.getElementById("HeaderGnaviPc_Favorite");
    
// Header Navigation（SP）    
var dom_HeaderLoginSp = document.getElementById("HeaderLoginSp");
var dom_HeaderRegisterSp = document.getElementById("HeaderRegisterSp");
var dom_HeaderGnaviSp_Top = document.getElementById("HeaderGnaviSp_Top");
var dom_HeaderGnaviSp_Collection = document.getElementById("HeaderGnaviSp_Collection");
var dom_HeaderGnaviSp_Blog = document.getElementById("HeaderGnaviSp_Blog");
var dom_HeaderGnaviSp_Favorite = document.getElementById("HeaderGnaviSp_Favorite");

// Footer Navigation
var dom_FooterNavi_Collection = document.getElementById("FooterNavi_Collection");
var dom_FooterNavi_Blog = document.getElementById("FooterNavi_Blog");
var dom_FooterNavi_Privacy = document.getElementById("FooterNavi_Privacy");
var dom_FooterNavi_Leagal = document.getElementById("FooterNavi_Leagal");
var dom_FooterNavi_Guide = document.getElementById("FooterNavi_Guide");
var dom_FooterNavi_Faq = document.getElementById("FooterNavi_Faq");


// ======================= 企業情報付与 ======================= 

if ( company_handle !== null ){

  // Header（Logo）
  var HeaderLogo = document.getElementById("HeaderLogo")
  var HeaderLogoImage = document.createElement('img');
  HeaderLogoImage.src = '//cdn.shopify.com/s/files/1/0566/1445/3305/files/' + company_handle + '.png';
  HeaderLogoImage.alt = company_handle;
  HeaderLogo.appendChild(HeaderLogoImage);
  if ( HeaderLogo.href == "https://salon-cu-ec.online/account" ){
    HeaderLogo.href = "https://salon-cu-ec.online/pages/" + company_handle;
  }

  // Header（商品を絞り込む）
  if( dom_HeaderCollection01 !== undefined ){
    dom_HeaderCollection01.href = "https://salon-cu-ec.online/collections/" + company_handle;    
  }
  if( dom_HeaderCollection02 !== undefined ){
    dom_HeaderCollection02.href = "https://salon-cu-ec.online/collections/" + company_handle;
  }
  
  // Header（検索フォーム）  
  if( dom_HeaderSearchInput !== undefined ){
    for(i=0;i<dom_HeaderSearchInput.length;i++){    
      dom_HeaderSearchInput[i].value = company_handle;
    }
  }

  //HeaderRegisterPc
  if( dom_HeaderRegisterPc !== undefined ){
    dom_HeaderRegisterPc.href = "https://salon-cu-ec.online/account/register?company=" + company_handle;
  }
  
  //HeaderAccountSp
  if( dom_HeaderAccountSp !== undefined ){
    dom_HeaderAccountSp.href = "https://salon-cu-ec.online/account?company=" + company_handle;
  }
  
  //HeaderAccountPc    
  if( dom_HeaderAccountPc !== undefined ){
    dom_HeaderAccountPc.href = "https://salon-cu-ec.online/account?company=" + company_handle;
  }
  
  // Header（カートドロワーのボタン）    
  if( dom_HeaderCartMove !== undefined ){
    dom_HeaderCartMove.href = "https://salon-cu-ec.online/cart?company=" + company_handle;
  }
  
  // Header Navigation（PC）    
  dom_HeaderGnaviPc_Top.href = "https://salon-cu-ec.online/pages/" + company_handle;      
  dom_HeaderGnaviPc_Collection.href = "https://salon-cu-ec.online/collections/" + company_handle;      
  dom_HeaderGnaviPc_Blog.href = "https://salon-cu-ec.online/blogs/" + company_handle;      
  dom_HeaderGnaviPc_Favorite.href = "https://salon-cu-ec.online/pages/wishlist/?company=" + company_handle;
      
  // Header Navigation（SP）
  dom_HeaderLoginSp.href = "https://salon-cu-ec.online/account/login?company=" + company_handle;
  dom_HeaderRegisterSp.href = "https://salon-cu-ec.online/account/register?company=" + company_handle;
  dom_HeaderGnaviSp_Top.href = "https://salon-cu-ec.online/pages/" + company_handle;
  dom_HeaderGnaviSp_Collection.href = "https://salon-cu-ec.online/collections/" + company_handle;        
  dom_HeaderGnaviSp_Blog.href = "https://salon-cu-ec.online/blogs/" + company_handle;        
  dom_HeaderGnaviSp_Favorite.href = "https://salon-cu-ec.online/pages/wishlist/?company=" + company_handle;    

  
  // Footer Navigation
  dom_FooterNavi_Collection.href = "https://salon-cu-ec.online/collections/" + company_handle;
  dom_FooterNavi_Blog.href = "https://salon-cu-ec.online/blogs/" + company_handle;
  dom_FooterNavi_Privacy.href = "https://salon-cu-ec.online/policies/privacy-policy?company=" + company_handle;
  dom_FooterNavi_Leagal.href = "https://salon-cu-ec.online/policies/legal-notice?company=" + company_handle;
  dom_FooterNavi_Guide.href = "https://salon-cu-ec.online/pages/guide-" + company_handle;
  dom_FooterNavi_Faq.href = "https://salon-cu-ec.online/pages/faq?company=" + company_handle;    

  // Mypage
  if( document.getElementById("MypageAddress_Button") !== null ){
    document.getElementById("MypageAddress_Button").href = "https://salon-cu-ec.online/account/addresses?company=" + company_handle;    
  }
  if( document.getElementById("MypageSubscription_Button") !== null ){
    document.getElementById("MypageSubscription_Button").href = "https://salon-cu-ec.online/apps/floor-s?company=" + company_handle;    
  }
  
  // Breadcrumb
  if( document.getElementById("Breadcrumb_Account") !== null ){
  document.getElementById("Breadcrumb_Account").href = "https://salon-cu-ec.online/account?company=" + company_handle;    
  }
  
  
}else{

  // 企業情報を取得できなかった場合bodyにクラス付与
  if( !document.body.classList.contains("in-company") ){    
    document.body.classList.add("company_unknown"); 
  }
  
  
}

/*
==============================================================================
企業情報が取得できなかった場合の処理
==============================================================================
*/


// 企業不明の場合サイト共通ロゴ表示
var HeaderLogo = document.getElementById("HeaderLogo")
if ( HeaderLogo.children.length == 0 ){
  
  var HeaderLogoImage = document.createElement('img');
  HeaderLogoImage.src = 'https://cdn.shopify.com/s/files/1/0566/1445/3305/files/logo_150x.png?v=1643180199';    
  HeaderLogo.appendChild(HeaderLogoImage);  
}